import axios from 'axios';

const NetworkBrandFiltersAPI = {
  getFilters(networkId, params = {}) {
    return axios.get(`/networks/${networkId}/brand-filters`, { params }).then((response) => {
      return response.data;
    });
  },

  createFilter(networkId, data) {
    return axios.post(`/networks/${networkId}/brand-filters`, data).then((response) => {
      return response.data;
    });
  },

  updateFilter(networkId, filterId, data) {
    return axios.post(`/networks/${networkId}/brand-filters/${filterId}`, data).then((response) => {
      return response.data;
    });
  },

  deleteFilter(networkId, filterId) {
    return axios.delete(`/networks/${networkId}/brand-filters/${filterId}`).then((response) => {
      return response.data;
    });
  },
};

export default NetworkBrandFiltersAPI;
